<template>
  <el-button
    size="small"
    class="DealDetailsTogglerButton elevationShadow--1"
    @click="toggle"
  >
    <slot />
  </el-button>
</template>

<script>
import Vue from 'vue';
import { Button } from 'element-ui';

Vue.use(Button);

export default {
  name: 'DealDetailsTogglerButton',
  methods: {
    toggle() {
      this.$emit('toggle');
    },
  },
};
</script>

<style scoped lang="scss">
.DealDetailsTogglerButton {
  border: 0;
  outline: 0;
}
</style>
